require('./brokerWarrantsBuyStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { InputSafe } = require('commonsComponents/inputSafe');
const { AmountInput } = require('commonsComponents/amountInput');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ actions
const BrokerWarrantsBuyActions = require('actions/brokerWarrantsBuy');
const BlockedAccounts = require('actions/blockedAccounts');

// @constants
const {
    FIRST_STEP,
    BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER,
    BROKER_WARRANTS_BUY_BUYFOR_TITLES,
    BROKER_WARRANTS_BUY_BUYFOR_AMOUNT,
    MAX_FRACTION_LENGTH_IN_STORE
} = require('constants/index');
const { WARRANTS_BUY_CODE } = require('constants/operationCodesAccounts');

class BrokerWarrantsBuyStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleBuyForRadiosChange = this.handleBuyForRadiosChange.bind(this);
        this.handleTitleQuantityChange = this.handleTitleQuantityChange.bind(this);
        this.onApproxImportChange = this.onApproxImportChange.bind(this);
        this.onHandleLimitPriceChange = this.onHandleLimitPriceChange.bind(this);
    }

    componentDidMount(){
        const { immAccounts, getBlockedAccounts } = this.props;

        getBlockedAccounts(immAccounts.get('byId').toList(), WARRANTS_BUY_CODE);
    }

    onApproxImportChange(price) {
        this.props.buyForValueChanged(price);
    }

    onHandleLimitPriceChange(newPrice) {
        this.props.limitPriceChanged(newPrice);
    }

    buildStocksContractDropdownOptions() {
        const { immStocksContracts } = this.props;

        const processedStocksContract = immStocksContracts.map((entry, index) => {
            const associatedAccountBalance = {
                amount: entry.getIn(['associatedAccountBalance', 'amount']),
                currency: entry.getIn(['associatedAccountBalance', 'currency'])
            };

            return entry.merge({
                value: index,
                walletBalance: associatedAccountBalance
            });
        });

        return processedStocksContract.toJS();
    }

    handleBuyForRadiosChange(value) {
        const { buyForOptionChanged } = this.props;
        buyForOptionChanged(value);
    }

    handleTitleQuantityChange(event) {
        const VALID_INTEGER_OR_EMPTY = /^(-?((\d)|(\d*)))?$/;
        if (VALID_INTEGER_OR_EMPTY.test(event.target.value)) {
            this.props.buyForValueChanged(event.target.value);
        }
    }

    render() {
        const { immBrokerWarrantsBuy, stockContractChanged, productCurrency, immStocksContracts, immAccounts } = this.props;
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        const stocksContractSelectedValue = immBrokerWarrantsBuy
            .get('steps')
            .get(FIRST_STEP)
            .get('stocksContractSelectedValue');
        const stocksContractPlaceholder = formatText('broker-stocksContractDropdownPlaceholder');
        const step1 = immBrokerWarrantsBuy.get('steps').get(FIRST_STEP);
        const limitPrice = step1.get('orderTypeValue');
        const buyForOption = step1.get('buyForOption');
        const buyForValue = step1.get('buyForValue');
        const errorFlags = step1.get('errorFlags');
        const buyForAmountLabel = `${formatText('broker-warrantsBuyViewBuyForAmount')}`;
        const language = getLanguage();

        const buyForTitlesInputCustomClass = classNames(
            'warrants-buy-step1__input warrants-buy-step1__buy-for-input--titles',
            {
                hidden: buyForOption === BROKER_WARRANTS_BUY_BUYFOR_AMOUNT
            }
        );
        const buyForAmountInputCustomClass = classNames(
            'warrants-buy-step1__input warrants-buy-step1__buy-for-input--amount',
            {
                hidden: buyForOption === BROKER_WARRANTS_BUY_BUYFOR_TITLES
            }
        );
        const buyForTitlesInput = (
            <div className={buyForTitlesInputCustomClass}>
                <InputSafe
                    type="text"
                    autoComplete="off"
                    value={buyForValue}
                    onChange={this.handleTitleQuantityChange}
                    errorState={errorFlags.get('buyForValue')}
                    errorMessage={formatText('broker-warrantsBuyViewBuyForTitlesError')}
                />
            </div>
        );
        const buyForAmountInput = (
            <div className={buyForAmountInputCustomClass}>
                <AmountInput
                    amount={buyForValue}
                    callback={this.onApproxImportChange}
                    error={errorFlags.get('buyForValue')}
                    errorMsg={formatText('broker-warrantsBuyViewBuyForAmountError')}
                    hideFocusZero={true}
                    language={language}
                />
            </div>
        );

        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        let dropdownSection;

        if (this.props.immMyInvestments.get('isFetching')) {
            dropdownSection = <LoadingSection/>;
        } else {
            dropdownSection = (
                <StocksContractDropdown
                    immAccounts={immAccounts}
                    immBrokerStocksContract={immStocksContracts}
                    onStockContractChange={stockContractChanged}
                    options={stocksContractDropdownOptions}
                    selectedValue={stocksContractSelectedValue}
                    placeholder={stocksContractPlaceholder}
                    modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER}
                    errorState={errorFlags.get('stocksContract')}
                    errorMessage={formatText('broker-warrantsBuyViewStockContractError')}
                    loading={isBlockedAccountsLoading}
                />
            );
        }

        return (
            <div className="warrants-buy-step1">
                <header className="warrants-buy-step1__header">
                    <h2 className="warrants-buy-step1__header-title">
                        <FormattedText value="broker-warrantsBuyViewStep1HeaderTitle" />
                    </h2>
                </header>

                <div className="stocks-warrants-buy-step1__dropdown">
                    {dropdownSection}
                </div>

                <div className="warrants-buy-step1__group-div">
                    <h2 className="warrants-buy-step1__subtitle warrants-buy-step1__subtitle--inline">
                        <FormattedText value="broker-warrantsBuyStep1BuyForText" />
                        <OKTooltip
                            content="broker-warrantsBuyViewBuyForTooltipText"
                            offset={[0, -10]}
                        />
                    </h2>

                    <RadioButtonGroup
                        selectedValue={buyForOption}
                        onChange={this.handleBuyForRadiosChange}
                        name="buyForRadioGroup"
                        idPrefix="buyForRadioGroup"
                    >
                        <RadioButton
                            label={formatText('broker-warrantsBuyViewBuyForTitles')}
                            value={BROKER_WARRANTS_BUY_BUYFOR_TITLES}
                            className="warrants-buy-step1__radio-button"
                        />
                        <RadioButton
                            label={buyForAmountLabel}
                            value={BROKER_WARRANTS_BUY_BUYFOR_AMOUNT}
                            className="warrants-buy-step1__radio-button"
                        />
                    </RadioButtonGroup>
                    {buyForTitlesInput}
                    {buyForAmountInput}
                </div>

                <div className="warrants-buy-step1__group-div">
                    <h2 className="warrants-buy-step1__subtitle warrants-buy-step1__subtitle--inline">
                        <FormattedText value="broker-warrantsBuyViewStep1LimitPriceLabel" /> ({productCurrency})
                    </h2>
                    <div className="warrants-buy-step1__input">
                        <AmountInput
                            amount={limitPrice}
                            callback={this.onHandleLimitPriceChange}
                            error={errorFlags.get('orderTypeValue')}
                            errorMsg={formatText('broker-warrantsBuyViewLimitPriceError')}
                            maxBackEndFractionLength={MAX_FRACTION_LENGTH_IN_STORE}
                            language={language}
                            hideFocusZero
                        />
                    </div>
                </div>
            </div>
        );
    }
}

BrokerWarrantsBuyStep1.propTypes = {
    immBrokerWallets: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerWarrantsBuy: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    stockContractChanged: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    buyForOptionChanged: PropTypes.func.isRequired,
    buyForValueChanged: PropTypes.func.isRequired,
    buyForValueReset: PropTypes.func.isRequired,
    limitPriceChanged: PropTypes.func.isRequired,
    productCurrency: PropTypes.string,
    productPrice: PropTypes.number.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    warrantTransactionCost: PropTypes.func.isRequired,
    fundIsin: PropTypes.string.isRequired
};

module.exports.constructor = BrokerWarrantsBuyStep1;

module.exports.BrokerWarrantsBuyStep1 = connect(
    state => ({
        immBrokerWallets: state.brokerWallets,
        immAccounts: state.accounts,
        immBrokerWarrantsBuy: state.brokerWarrantsBuy,
        immStocksContracts: state.brokerStocksContract,
        immMyInvestments: state.brokerMyInvestments
    }),
    {
        getBlockedAccounts: BlockedAccounts.getBlockedAccounts,
        stockContractChanged: BrokerWarrantsBuyActions.stockContractChanged,
        buyForOptionChanged: BrokerWarrantsBuyActions.buyForOptionChanged,
        buyForValueChanged: BrokerWarrantsBuyActions.buyForValueChanged,
        buyForValueReset: BrokerWarrantsBuyActions.buyForValueReset,
        limitPriceChanged: BrokerWarrantsBuyActions.limitPriceChanged
    }
)(BrokerWarrantsBuyStep1);
